/**
 * @file test-case.form.tsx
 * @description Форма для создания и редактирования тестовых случаев в системе тестирования.
 * Включает поля для указания сервиса, функции, группы тестирования, URL запроса и тела запроса.
 * Позволяет настраивать HTTP запросы для автоматизированного тестирования API.
 * Интегрируется с react-hook-form через control prop.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @components/form-controls/text-field, @components/form-controls/dictionary]
 * @related-files [@components/form-controls/text-field/text-field.component.tsx, @components/form-controls/dictionary/dictionary.component.tsx]
 */

import { TextField } from '@components/form-controls/text-field';
import { Dictionary } from '@components/form-controls/dictionary';
// import { ITestCaseDTO } from '@src/types/dto'; // DTO доступно для AI помощников

export const TestCaseForm = ({ control }: any) => {
    return (
        <div className="flex flex-col gap-[1.0585vmin]">
            <Dictionary label="Сервис" name="service" control={control} />

            <Dictionary label="Функция" name="functionalRequirement" control={control} />

            <Dictionary label="Группа" name="group" control={control} />

            <TextField label="URL" name="requestUrl" control={control} />

            <TextField label="BODY" name="requestBody" type="textarea" minRows={8} control={control} />
        </div>
    );
};
